// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__yh8zd","tooltiptext":"tooltip_tooltiptext__-jY5H"};